import { create } from 'zustand'

type BasicFormSyncStoreState = {
    syncedState: any | undefined
    setSyncState: (config: any) => void
    unsavedCount: number
    setUnsavedCount: (count: number) => void
    increaseUnsavedCountByOne: () => void
}

export const useBasicFormSyncStore = create<BasicFormSyncStoreState>((set, get) => ({
    unsavedCount: 0,
    syncedState: undefined,
    setUnsavedCount: (count: number) => {
        set(() => ({ ...get(), unsavedCount: count }))
    },
    increaseUnsavedCountByOne: () => {
        set(() => ({ ...get(), unsavedCount: get().unsavedCount + 1 }))
    },
    setSyncState: (config) => {
        set(() => ({
            syncedState: config,
            unsavedCount: get().unsavedCount + 1
        }))
    }
}))
